module.exports = __webpack_public_path__ + "img/product-detail-promo-bg-900-591.c2db6a8.jpg";